export const calculateMarginalROI = (curveCoordinates: [number, number][]): [number, number][] => {
  return curveCoordinates.reduce<[number, number][]>((result, currentPoint, index) => {
    if (index === 0) return result; // Skip the first point

    const [currentSpend, currentRevenue] = currentPoint;
    const prevPoint = curveCoordinates[index - 1];
    if (!prevPoint) return result; // Ensure prevPoint is not undefined

    const [prevSpend, prevRevenue] = prevPoint;
    const deltaSpend = currentSpend - prevSpend;
    const deltaRevenue = currentRevenue - prevRevenue;

    if (deltaSpend !== 0) {
      // Only calculate if deltaSpend is not zero
      const marginalROI = deltaRevenue / deltaSpend;
      result.push([currentSpend, marginalROI]);
    }

    return result;
  }, []);
};
